export enum ResourcesApplicationType {
  erp,
  portal,
}

export enum DisplayMode {
  list,
}
export const AllGroups = 'All';
